import sal from 'sal.js';
import headerHandler from './partials/_header.js';
import navigation from './partials/_navigation.js';
import slidersHandler from './partials/_sliders.js';
import tabsHandler from './partials/_tabs.js';
import offerFormHandler from './partials/_offer-form.js';
import svgHandler from './partials/_svg-map.js';

document.addEventListener('DOMContentLoaded', () => {
	headerHandler();
	navigation();
	slidersHandler();
	tabsHandler();
	offerFormHandler();
	svgHandler();

	animations();


	document.querySelectorAll('a[href^="tel:"]').forEach(item => {
		item.addEventListener('click', e => {
			fbq('track', 'Lead');
			pintrk('track', 'Lead');
		})
	})
	
	document.addEventListener( 'wpcf7submit', function( event ) {
		fbq('track', 'Contact')
		pintrk('track', 'Custom');
	  }, false );
	  
	document.body.className = document.body.className.replace('no-js', 'js');

	if (isMacOS()) {
		document.documentElement.classList.add('is-macos');
	}
});

function animations() {
	const animations = sal({
		threshold: 0.1,
		once: true,
	});

	if (window.matchMedia('(max-width: 768px)').matches) {
		animations.disable();
	}
}

function isMacOS() {
	return navigator.userAgent.toUpperCase().includes('MAC');
}